import barba, { ITransitionData } from '@barba/core'
import barbaPrefetch from '@barba/prefetch'
import slide, { resetAfterEntry } from './barba/slide'
import { initComponents } from '../components-front';
import lightGallery from 'lightgallery';
import { researchBriefs } from '../researchbriefs';
import { initLittlefoot } from './littlefoot';
import { initVue } from '../vue';

// barba.use(barbaPrefetch)

/*
 *  Hook Lifecycle:
 * +------+---------------+--------------------------------------------------------------------------------+
 * |  #   |   Hook Name   |                                  Description                                   |
 * +------+---------------+--------------------------------------------------------------------------------+
 * |  1   |  beforeOnce   |                  Before once transition (browser first load)                   |
 * |  2   |     once      |               Current page once transition (browser first load)                |
 * |  3   |    before     |                               Before everything                                |
 * |  4   |  beforeLeave  |                            Before leave transition                             |
 * |  5   |  beforeEnter  |                            Before enter transition                             |
 * |  6   |     leave     |                         Current page leave transition                          |
 * |  7   |     enter     |  Next page enter transition (Same time as leave, next container is DOM ready)  |
 * |  8   |   afterOnce   |                   After once transition (browser first load)                   |
 * |  9   |  afterLeave   |                             After leave transition                             |
 * |  10  |  afterEnter   |                             After enter transition                             |
 * |  11  |     after     |                                After everything                                |
 * +------+---------------+--------------------------------------------------------------------------------+
 */

barba.hooks.before(() => {
    barba.wrapper.classList.add('is-animating')
})

barba.hooks.enter(() => {
    initComponents();
})

barba.hooks.afterLeave(() => {
    initComponents('afterLeave')
})

barba.hooks.afterEnter((data) => {
    initComponents('afterEnter')
    initLightGallery(data);
    initResearchBriefs();
    if (!data.next.url.path.includes('research-briefs')) {
        initVue();
    }
    hideEmptyShortTextWrapper(data);
    hideEmptyBlockQuotes(data);
    hideEmptyImages(data);
    refreshModals(data);
    refreshH1s(data);
})

barba.hooks.after(() => {
    barba.wrapper.classList.remove('is-animating')
    initComponents('after')
    initLittlefoot();
    window.AOS.refresh();
})

function hideEmptyShortTextWrapper(data) {
    const shortTextWrappers = data.next.container.querySelectorAll('.short-text-wrapper');
	shortTextWrappers.forEach(wrapper => {
		if (!wrapper.textContent.trim()) {
			wrapper.classList.add('d-none');
		}
	});
}

function hideEmptyBlockQuotes(data) {
    const shortBlockQuotes = data.next.container.querySelectorAll('.short-blockquote');
    shortBlockQuotes.forEach(wrapper => {
        if (!wrapper.textContent.trim()) {
            wrapper.classList.add('d-none');
            wrapper.parentElement.classList.add('d-none');
        }
    });
}

function hideEmptyImages(data) {
    // Remove empty images on research articles
	if (data.next.url.path.includes('research-briefs')) {
		const images = data.next.container.querySelectorAll('[data-type="ComponentImage"]');
		images.forEach(image => {
			if (!image.querySelector('img')) {
				image.classList.add('d-none');
				let parentSection = image.closest('section');
				if (parentSection) {
					let parent = image.parentElement;
					while (parent && parent.parentElement !== parentSection) {
						parent = parent.parentElement;
					}
					if (parent) {
						parent.classList.add('d-none');
					}
				}
			}
		});
	}
}

function initLightGallery(data) {
    const lightGalleryItems = data.next.container.querySelectorAll('.lightgallery--wrapper');
    lightGalleryItems.forEach(element => {
        try {
            $(`#${element.id}`).lightGallery();
        } catch (ex) {
            console.log(ex);
        }
    });
}

function initResearchBriefs() {
    researchBriefs();
}

function refreshModals(data) {
    const modals = data.next.container.querySelectorAll('.modal');
    if (modals) {
        modals.forEach(modal => {
            data.next.container.parentElement.parentElement.appendChild(modal);
        });
    }
}

function refreshH1s(data) {
    const pathname = data.next.url.path;
    const validPathsToShowTitleAsH1 = [
        '/'
    ];
    if (!validPathsToShowTitleAsH1.includes(pathname)) {
        const title = data.next.container.parentElement.parentElement.querySelector('#home-heading');
        if (title) {
            const newTitle = document.createElement('div');
            newTitle.classList.add('d-flex', 'flex-column', 'mb-0');
            newTitle.innerHTML = title.innerHTML;
            title.parentNode.replaceChild(newTitle, title);
        }
    } else {
        const logoLink = data.next.container.parentElement.parentElement.querySelector('#logo-link');
        if (logoLink) {
            const newLogoLink = document.createElement('h1');
            newLogoLink.classList.add('d-flex', 'flex-column', 'mb-0');
            newLogoLink.id = 'home-heading';
            newLogoLink.innerHTML = logoLink.parentElement.innerHTML;
            logoLink.parentNode.replaceChild(newLogoLink, logoLink.parentElement);
        }
    }
}

/**
 * @param {string} transition
 * @return {(ITransitionData) => boolean}
 */
function useTransition(transition) {
    return function({ current, next, trigger }) {
        if (trigger.dataset.transition) {
            return trigger.dataset.transition === transition
        }
        const currentPostId = parseInt(current.container.dataset.postId)
        const nextPostId = parseInt(next.container.dataset.postId)
        const transitions = JSON.parse(current.container.dataset.transitions)
        const find = transitions.find(t => {
            return parseInt(t['from_id']) === currentPostId && parseInt(t['to_id']) === nextPostId && t['type'] === transition
        })
        return !!find
    }
}

export default function() {
    addEventListener('DOMContentLoaded', _ => {
        barba.init({
            // debug: true,
            timeout: 2e4,
            transitions: [
                {
                    sync: true,
                    custom: useTransition('slide-left'),
                    enter: ({ next }) => slide(next.container, 'enter', 'prev'),
                    leave: ({ current }) => slide(current.container, 'leave', 'prev'),
                    afterEnter: ({ next }) => resetAfterEntry(next.container),
                },
                {
                    sync: true,
                    custom: useTransition('slide-right'),
                    enter: ({ next }) => slide(next.container, 'enter', 'next'),
                    leave: ({ current }) => slide(current.container, 'leave', 'next'),
                    afterEnter: ({ next }) => resetAfterEntry(next.container),
                },
                {
                    sync: true,
                    custom: useTransition('slide-up'),
                    enter: ({ next }) => slide(next.container, 'enter', 'prev', false),
                    leave: ({ current }) => slide(current.container, 'leave', 'prev', false),
                    afterEnter: ({ next }) => resetAfterEntry(next.container),
                },
                {
                    sync: true,
                    custom: useTransition('slide-down'),
                    enter: ({ next }) => slide(next.container, 'enter', 'next', false),
                    leave: ({ current }) => slide(current.container, 'leave', 'next', false),
                    afterEnter: ({ next }) => resetAfterEntry(next.container),
                },
                {
                    name: 'back',
                    priority: 1,
                    custom: ({ trigger }) => {return trigger === 'back'},
                    enter: ({ next }) => slide(next.container, 'enter', 'prev'),
                    leave: ({ current }) => slide(current.container, 'leave', 'prev'),
                    afterEnter: ({ next }) => resetAfterEntry(next.container),
                },
                {
                    name: 'forward',
                    priority: 1,
                    custom: ({ trigger }) => {return trigger === 'forward'},
                    enter: ({ next }) => slide(next.container, 'enter', 'next'),
                    leave: ({ current }) => slide(current.container, 'leave', 'next'),
                    afterEnter: ({ next }) => resetAfterEntry(next.container),
                },
            ],
            requestError: (trigger, action, url, response) => {
                console.log(trigger, action, url, response)
            },
        })
    })
}
